import type {Optional} from '@logistics-frontend/types'
import {get} from '@logistics-frontend/utils'

import type {Point, PointID} from 'src/shared/types'

export const getPointId: (point?: Point) => Optional<PointID> = get('_id')
